/*** IMPORTS FROM imports-loader ***/
var global = window;

'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

